<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý điểm danh</h1>
      <div class="btn-group float-right">
        <DraggableTable :naming="$route.name" v-model="fieldTable" @change="filterTable = $event" />
        <button @click="exportExcel" class="f12 font-medium btn btn-outline-secondary">
            <i class='bx bx-download'></i> Xuất file
        </button>
        <button @click="waittingApprovedAttendance" class="f12 font-medium btn btn-outline-secondary">
          Chờ duyệt chấm công
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em" class="text-center font-size-12">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group" v-if="saleAdmin.includes(dataUser.typeSale) || saleLeader.includes(dataUser.typeSale) || regionDirector.includes(dataUser.typeSale) || superAdmin.includes(dataUser.typeSale)">
            <Select2
              placeholder="Vùng"
              v-model="search.region"
              :options="dataRegion"
              @change="queryProvince($event)"
            />
          </div>
          <div class="form-group" v-if="saleAdmin.includes(dataUser.typeSale) || saleLeader.includes(dataUser.typeSale) || regionDirector.includes(dataUser.typeSale) || superAdmin.includes(dataUser.typeSale)">
            <Select2
            placeholder="Tỉnh/TP"
            v-model="search.province"
            :options="dataProvince" />
          </div>
          <div class="form-group" v-if="saleAdmin.includes(dataUser.typeSale) || saleLeader.includes(dataUser.typeSale) || regionDirector.includes(dataUser.typeSale) || superAdmin.includes(dataUser.typeSale)">
            <Select2
            placeholder="Quản lý"
            v-model="search.superior"
            :options="dataManager" />
          </div>
          <div class="form-group" v-if="saleAdmin.includes(dataUser.typeSale) || saleLeader.includes(dataUser.typeSale) || regionDirector.includes(dataUser.typeSale) || superAdmin.includes(dataUser.typeSale)">
            <Select2
            placeholder="Nhân viên"
            v-model="search.saleId"
            :options="dataStaff" />
          </div>

          <div class="form-group" v-if="saleAdmin.includes(dataUser.typeSale) || saleLeader.includes(dataUser.typeSale) || regionDirector.includes(dataUser.typeSale) || superAdmin.includes(dataUser.typeSale)">
            <Select2
              placeholder="Trạng thái duyệt checkin"
              v-model="search.checkInStatus"
              :options="listStatusCheckIn"
            />
          </div>
          <div class="form-group" v-if="saleAdmin.includes(dataUser.typeSale) || saleLeader.includes(dataUser.typeSale) || regionDirector.includes(dataUser.typeSale) || superAdmin.includes(dataUser.typeSale)">
            <Select2
              placeholder="Trạng thái duyệt checkout"
              v-model="search.checkOutStatus"
              :options="listStatusCheckIn"
            />
          </div>
          <div class="form-group form-group-action">
            <button @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top" title="Lọc">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top" title="Bỏ lọc">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng bản điểm danh: {{ pagination.total }}
            <b-table :busy.sync="loading" sticky-header hover responsive :items="dataAttentdent" :fields="filterTable" :fixed="true" :bordered="true">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(staff)="data">
                <b>{{ data.item.name }}</b><br>
                Vị trí: <b>{{ data.item.typeSale | transformData(listTypeSale) }}</b>
                <p v-if="data.item.userName">
                  <a href="#" @click="openDetailStaff(data.item)" class="text-0A63AB">{{ data.item.userName }}</a>
                </p>
                <p>
                  Ngày vào làm việc: <br/>
                  {{ data.item.companyDayInTime | formatDate }}
                </p>
              </template>
              <template #cell(dayOfWeek)="data">
                {{ data.item.dayOfWeek | formatDay }} <br />{{ data.item.date }}
              </template>
              <template #cell(imgCheckin)="data">
                <img
                  v-viewer
                  class="image-checkInOut"
                  :src="(data.item.imageUrlsCheckin && data.item.imageUrlsCheckin.length > 0) ? data.item.imageUrlsCheckin[0] : ''"
                  alt="">
              </template>
              <template #cell(imgCheckout)="data">
                <img
                v-viewer
                  class="image-checkInOut"
                  :src="(data.item.imageUrlsCheckout && data.item.imageUrlsCheckout.length > 0) ? data.item.imageUrlsCheckout[data.item.imageUrlsCheckout.length - 1] : ''"
                  alt="">
              </template>
              <template #cell(latitudeCheckin)="data">
                <div v-if="data.item.latitudeCheckin && data.item.longtitudeCheckin">
                  <a href="#" @click="showMapModal(data.item.latitudeCheckin, data.item.longtitudeCheckin)">
                    <span v-if="data.item.addressCheckIn">{{ data.item.addressCheckIn }}</span>
                    <span v-else>{{ data.item.latitudeCheckin | placeHolder }} / {{ data.item.longtitudeCheckin | placeHolder }}</span>
                  </a>
                </div>
              </template>
              <template #cell(latitudeCheckout)="data">
                <div v-if="data.item.latitudeCheckout && data.item.longtitudeCheckout">
                  <a href="#" @click="showMapModal(data.item.latitudeCheckout, data.item.longtitudeCheckout)">
                    <span v-if="data.item.addressCheckOut">{{ data.item.addressCheckOut }}</span>
                    <span v-else>{{ data.item.latitudeCheckout | placeHolder}} / {{ data.item.longtitudeCheckout | placeHolder}}</span>
                  </a>
                </div>
              </template>
              <template #cell(checkInApprove)="data">
                <span class="badge" :class="[data.item.checkInStatus ? data.item.checkInStatus : '']">
                  {{ data.item.checkInStatus | mapTextStatus(listStatusCheckIn) }}
                </span>
                <p class="mt-1">{{ data.item.checkInApprovedDate ? data.item.checkInApprovedDate : '' }}</p>
                <b-button @click="onApproveAttend(data.item,'checkin')" size="sm" v-if="data.item.checkInStatus === 'WAITING' && dataPermission && dataPermission.includes('CNPS_ATTN_APPROVE')" variant="success">Duyệt</b-button>
              </template>
              <template #cell(checkOutApprove)="data">
                <span class="badge" :class="[data.item.checkOutStatus ? data.item.checkOutStatus : '']">
                  {{ data.item.checkOutStatus | mapTextStatus(listStatusCheckIn) }}
                </span>
                <p class="mt-1">{{ data.item.checkOutApprovedDate ? data.item.checkOutApprovedDate : '' }}</p>
                <b-button @click="onApproveAttend(data.item,'checkout')" size="sm" v-if="data.item.checkOutStatus === 'WAITING' &&
                  dataPermission && dataPermission.includes('CNPS_ATTN_APPROVE')" variant="success">Duyệt</b-button>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item class="dropdown-item" @click='detailAttendance(data.item)'>
                    <i class="bx bx-reset"></i><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.size"
          class="fl-right mr-2"
        ></b-pagination>
      </div>
    </div>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg">
      <div>
        <GmapMap
          :center="{lat: latitude, lng: longtitude}"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker
          :position="{lat: latitude, lng: longtitude}"
        ></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
    <b-modal id="modal-scoped" centered v-model='notiModal'>
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button type="button" class="close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class='text-center'>
        <img :src='iconNoti' :alt="iconNoti">
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()">
          Đóng
        </b-button>
      </template>
    </b-modal>

     <b-modal id="approve-attend" size="lg" centered hide-footer hide-header>
      <div class="card-body p-10 b-t-1-869fb229">
        <span class="de-img"><img :src="userDefaultImage" alt="img"></span>
        <div class="de-info">
          <h3 class="de-name">{{ approveAttend.name }}</h3>
          <span class="s">Mã: {{ approveAttend.companyCode }}</span>
        </div>
        <div class="clearfix"></div>
        <div class="form-row">
          <div class="col-md-12 my-2" v-if="approveAttend.type === 'checkin'">
            <h1 class="f16 pb-1"><b>Checkin</b></h1>
              <div class="my-2 box-detail mb-4">
                <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group row mb-0">
                        <label class="col-sm-3 col-form-label f14">Thời gian</label>
                        <div class="col-sm-9">
                          <p class="form-control-plaintext f14">{{ approveAttend.timeCheckin }}</p>
                        </div>
                      </div>
                      <div class="form-group row mb-0">
                        <label class="col-sm-3 col-form-label f14">Ghi chú</label>
                        <div class="col-sm-9">
                          <p type="text" class="form-control-plaintext f14">{{ approveAttend.note }}</p>
                        </div>
                      </div>
                      <div class="form-group row mb-0">
                        <label class="col-sm-3 col-form-label f14">Địa điểm</label>
                        <div class="col-sm-9">
                          <a href="#" @click="showMapModal( approveAttend.latitudeCheckin, approveAttend.longtitudeCheckin )" class="f14">
                            <span v-if="approveAttend.addressCheckIn">{{ approveAttend.addressCheckIn }}</span>
                            <span v-else>{{ approveAttend.latitudeCheckin | placeHolder}} / {{approveAttend.longtitudeCheckin | placeHolder}}</span>
                          </a>
                        </div>
                      </div>
                      <div class="form-group row mb-0" v-if="approveAttend.checkInStatus">
                        <label class="col-sm-3 col-form-label f14">Trạng thái</label>
                        <div class="col-sm-9 d-flex align-items-center">
                          <span
                            class="badge"
                            v-bind:class="[approveAttend.checkInStatus ? approveAttend.checkInStatus : '']"
                            >{{
                              approveAttend.checkInStatus | mapTextStatus(listStatusCheckIn)
                            }}</span
                          >
                        </div>
                      </div>
                      <div
                        class="form-group row mt-3"
                        v-if="approveAttend.checkInStatus && approveAttend.checkInStatus === 'WAITING' &&
                        dataPermission && dataPermission.includes('CNPS_ATTN_APPROVE')"
                      >
                        <label class="col-sm-3 col-form-label f14"></label>
                        <div class="col-sm-9">
                          <b-button variant="success" @click="approveAttendance(approveAttend.checkInId)" class="mr-2">Duyệt</b-button>
                          <b-button variant="danger" @click="showRejectAttendance(approveAttend.checkInId)">Từ chối</b-button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6" v-if="approveAttend.imageUrlsCheckin">
                      <img width="300px" style="height: 300px" v-viewer :src="approveAttend.imageUrlsCheckin[0]" alt=""/>
                    </div>
                </div>
              </div>
          </div>
          <div class="col-md-12 my-2" v-else>
            <h1 class="f16 pb-1"><b>Chekout</b></h1>
            <div class="form-row">
                <div class="col-md-6">
                  <div class="my-2 box-detail mb-4">
                    <div class="form-group row mb-0">
                      <label class="col-sm-3 col-form-label f14">Thời gian</label>
                      <div class="col-sm-9">
                        <p class="form-control-plaintext f14">{{ approveAttend.timeCheckout}}</p>
                      </div>
                    </div>
                    <div class="form-group row mb-0">
                      <label class="col-sm-3 col-form-label f14">Ghi chú</label>
                      <div class="col-sm-9">
                        <p type="text" class="form-control-plaintext f14">{{ approveAttend.note }}</p>
                      </div>
                    </div>
                    <div class="form-group row mb-0">
                      <label class="col-sm-3 col-form-label f14">Địa điểm</label>
                      <div class="col-sm-9">
                        <a href="#" @click="showMapModal(approveAttend.latitudeCheckout, approveAttend.longtitudeCheckout)" class="f14">
                          <span v-if="approveAttend.addressCheckOut">{{approveAttend.addressCheckOut}}</span>
                          <span v-else>{{approveAttend.latitudeCheckout | placeHolder}} / {{approveAttend.longtitudeCheckout | placeHolder}}</span>
                        </a>
                      </div>
                    </div>
                    <div class="form-group row mb-0" v-if="approveAttend.checkOutStatus">
                      <label class="col-sm-3 col-form-label f14">Trạng thái</label>
                      <div class="col-sm-9 d-flex align-items-center">
                        <span
                          class="badge"
                          v-bind:class="[approveAttend.checkOutStatus ? approveAttend.checkOutStatus : '']"
                          >{{
                            approveAttend.checkOutStatus | mapTextStatus(listStatusCheckIn)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="form-group row mt-3"
                      v-if="approveAttend.checkOutStatus && approveAttend.checkOutStatus === 'WAITING' &&
                      dataPermission && dataPermission.includes('CNPS_ATTN_APPROVE')"
                    >
                      <label class="col-sm-3 col-form-label f14"></label>
                      <div class="col-sm-9">
                        <b-button variant="success" @click="approveAttendance(approveAttend.checkOutId)" class="mr-2">Duyệt</b-button>
                        <b-button variant="danger" @click="showRejectAttendance(approveAttend.checkOutId)">Từ chối</b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" v-if="approveAttend.imageUrlsCheckout">
                  <img width="300px" style="height: 300px" v-viewer :src="approveAttend.imageUrlsCheckout[0]" alt=""/>
                </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading"
        :is-full-page="true">
    </VueLoadingOverlay>

    <div v-if="showModalReject">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Lý do từ chối
                  </h5>
                  <button
                    type="button"
                    class="close"
                    @click="showModalReject = false"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <form>
                    <div class="form-group pos-relative">
                      <textarea
                        v-model.trim="rejectReason"
                        class="form-control f12"
                      ></textarea>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    :disabled="
                      !rejectReason ||
                      !rejectReason.trim() ||
                      rejectReason.length < 2
                    "
                    @click="rejectAttendance()"
                    class="btn btn-success"
                  >
                    Xác nhận
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import userDefaultImage from '@/assets/img/user.svg'
import { AttentdentService } from '@/services/attentdent.service'
import { StaffService } from '@/services/staff.service'
import Config from '@/thirdParty/config'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import moment from 'moment'
import { mapGetters } from 'vuex'
const fieldTable = [
  { key: 'index', label: 'STT', class: 'text-center' },
  { key: 'staff', label: 'Nhân viên' },
  { key: 'provinceName', label: 'Tỉnh/ thành phố' },
  { key: 'dayOfWeek', label: 'Thứ' },
  { key: 'timeCheckin', label: 'Đăng nhập' },
  { key: 'timeCheckout', label: 'Đăng xuất' },
  { key: 'imgCheckin', label: 'Ảnh checkin' },
  { key: 'imgCheckout', label: 'Ảnh checkout' },
  { key: 'latitudeCheckin', label: 'Vị trí checkin' },
  { key: 'latitudeCheckout', label: 'Vị trí checkout' },
  { key: 'checkInApprove', label: 'Duyệt checkin' },
  { key: 'checkOutApprove', label: 'Duyệt checkout' },
  { key: 'lateMinute', label: 'Đến muộn' },
  { key: 'earlyMinute', label: 'Về sớm' },
  { key: 'superiorName', label: 'Quản lý' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]
export default {
  name: 'AttentdentList',
  mixins: [prepareQueryParamsMixin],
  mounted () {
    this.getDataSearch()
    this.fetchData()
    this.getRegions()
    this.fetchSuperiors()
    this.getListStaffBySuperior()
  },
  data () {
    return {
      listTypeSale: Config.listTypeSale,
      fieldTable,
      filterTable: fieldTable,
      rejectId: null,
      rejectReason: '',
      showModalReject: false,
      approveAttend: {},
      notiModal: false,
      iconNoti: '',
      msgNoti: '',
      userDefaultImage,
      search: {
        size: 50,
        page: 1,
        userId: JSON.parse(localStorage.getItem('userData')).userId
      },
      pagination: {
        total: 0
      },
      dataUser: JSON.parse(localStorage.getItem('userData')),
      saleAdmin: Config.saleAdmin,
      saleLeader: Config.saleLeader,
      regionDirector: Config.regionDirector,
      superAdmin: Config.superAdmin,
      localeData: Config.localeData,
      dataStaff: [],
      dataManager: [],
      dateRange: {
        startDate: null,
        endDate: null
      },
      dataAttentdent: [],
      error: false,
      loading: true,
      dataRegion: [],
      dataProvince: [],
      longtitude: 10,
      latitude: 10,
      listStatusCheckIn: [
        { id: '0', text: 'Tất cả' },
        { id: 'WAITING', text: 'Chờ duyệt' },
        { id: 'APRROVED', text: 'Đã duyệt' },
        { id: 'DENIED', text: 'Từ chối' }
      ],
      showLoading: false,
      actionReload: () => {}
    }
  },
  watch: {
    'search.page': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.actionReload()
    }
  },
  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission',
      dataSearch: 'search/getDataSearch'
    }),
    useInUrlQueryPropList () {
      return this.prepareQueryParamsMixin({
        size: this.search.size,
        page: this.search.page
      })
    }
  },
  methods: {
    showRejectAttendance (attnId) {
      this.$bvModal.hide('approve-attend')
      this.showModalReject = true
      this.rejectId = attnId
    },
    async rejectAttendance () {
      try {
        this.showModalReject = false
        this.showLoading = true
        const response = await AttentdentService.rejectAttendance({
          attnId: this.rejectId,
          rejectReason: this.rejectReason
        })
        if (response.code === 1000) {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-success2.svg')
          this.msgNoti = response.message
          await this.actionReload()
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = response.message
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.showLoading = false
      }
    },
    async approveAttendance (attnId) {
      try {
        this.$bvModal.hide('approve-attend')
        this.showLoading = true
        const response = await AttentdentService.approveAttendance({
          attnId
        })
        if (response.code === 1000) {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-success2.svg')
          this.msgNoti = response.message
          await this.actionReload()
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = response.message
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.showLoading = false
      }
    },
    onApproveAttend (item, type) {
      this.approveAttend = item
      this.approveAttend.type = type
      this.$bvModal.show('approve-attend')
    },
    // define ngày trên lịch
    transformDate () {
      this.search.fromDate = moment(this.dateRange.startDate)
        .startOf('day')
        .valueOf()
      this.search.endDate = moment(this.dateRange.endDate)
        .endOf('day')
        .valueOf()
    },
    // chuyển trang chi tiết
    detailAttendance (item) {
      this.$store.commit('search/SET_DATA_SEARCH', this.search)

      const time = moment(item.date, 'DD/MM/YYYY').valueOf()
      window.open(`/attendance/${item.userId}/${time}`)
    },
    // lấy vùng
    async getRegions () {
      const data = await StaffService.getRegions()
      if (data.data.length > 0) {
        this.dataRegion.push({
          id: '0',
          text: 'Tất cả'
        })
        data.data.map((e) => {
          this.dataRegion.push({ id: e.id, text: e.name })
        })
      }
    },
    // lấy tỉnh TP theo vùng
    async queryProvince (e) {
      try {
        const data = await StaffService.getProvinceRegion({ regionId: [e] })
        if (data.data.length > 0) {
          const dataProvince = [{
            id: '0',
            text: 'Tất cả'
          }]
          data.data.map((e) => {
            dataProvince.push({ id: e.id, text: e.name })
          })
          this.dataProvince = dataProvince
        }
      } catch (error) {}
    },
    // list quản lý
    async fetchSuperiors () {
      try {
        const { data } = await StaffService.superiors()
        this.dataManager.push({
          id: '0',
          text: 'Tất cả'
        })
        data.map((e) => {
          this.dataManager.push({ id: e.userName, text: `${e.name} - ${e.userName}` })
        })
      } catch (e) {
        console.error(e)
      }
    },
    // list nhân viên
    async getListStaffBySuperior () {
      try {
        const data = await StaffService.getStaffByIdSuperior({
          userId: this.dataUser.userId
        })
        if (data.data.length > 0) {
          this.dataStaff.push({
            id: '0',
            text: 'Tất cả'
          })
          data.data.map((e) => {
            this.dataStaff.push({ id: e.userId, text: `${e.name} - ${e.userName}` })
          })
        }
      } catch (error) {}
    },
    // lọc
    async submitForm (event) {
      event.preventDefault()
      this.pagination.page = 1
      this.fetchData()
    },
    // bỏ lọc
    async removeForm () {
      this.search = {
        size: 50,
        page: 1,
        userId: JSON.parse(localStorage.getItem('userData')).userId
      }
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      this.dataProvince = []
      await this.fetchData()
    },
    // xuất excel
    async exportExcel () {
      try {
        this.showLoading = true
        this.search.typeExport = 'DETAIL'
        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }
        const req = { ...this.search }
        delete req.size
        delete req.page
        await StaffService.export(req)
      } catch (error) {
        console.log(error)
      } finally {
        this.showLoading = false
      }
    },
    // data bảng
    async fetchData () {
      this.actionReload = this.fetchData
      this.loading = true
      try {
        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }
        const data = await AttentdentService.getList(this.search)
        this.dataAttentdent = data.data.content
        this.pagination.total = data.data.totalElements
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },

    async waittingApprovedAttendance () {
      this.actionReload = this.waittingApprovedAttendance
      this.loading = true
      this.pagination.page = 1
      try {
        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }
        const data = await AttentdentService.getWaitingApprovedAttendance(this.search)
        this.dataAttentdent = data.data.content
        this.pagination.total = data.data.totalElements
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },

    getDataSearch () {
      if (JSON.stringify(this.dataSearch) === '{}') {
        this.search = {
          size: 50,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId
        }
      } else {
        this.search = this.dataSearch
        this.dateRange.startDate = (new Date(this.search.fromDate)).toString()
        this.dateRange.endDate = (new Date(this.search.endDate)).toString()
        if (this.search.region) this.queryProvince(this.search.region)
        this.fetchData()
      }
    },

    showMapModal (lat, long) {
      this.latitude = parseFloat(lat)
      this.longtitude = parseFloat(long)
      this.$refs['modal-map'].show()
    },

    openDetailStaff (item) {
      window.open(`/staff/detail/?id=${item.userId}`, '_blank')
    }
  }
}
</script>

<style scoped>
.image-checkInOut{
  max-width: 10rem;
  max-height: 10rem;
}
.image-checkInOut:hover{
  cursor: pointer;
}
</style>
